import PropTypes from "prop-types";
import {Box} from "@mui/material";

Main.propTypes = {
    sx: PropTypes.object,
    children: PropTypes.node
};

export default function Main({children, sx, ...other}) {

    return (
        <Box
            component="main"
            sx={{
                overflow: "auto",
                flexGrow: 1,
            }}
            {...other}>
            {children}
        </Box>
    );
}
